module.exports = __webpack_public_path__ + "static/media/promo.29d4c911.png";